import {ArrowRight, Menu, Search, X} from 'lucide-react';
import { FormEvent, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const links = [
{ to: '/cursos', label: 'Cursos' },
{ to: '/instructores', label: 'Instructores' },
{ to: '/contacto', label: 'Contacto' }];


function Header() {
  const { isAuthenticated, isAdmin, user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const onSearch = (event: FormEvent) => {
    event.preventDefault();
    const value = query.trim();
    navigate(value ? `/cursos?q=${encodeURIComponent(value)}` : '/cursos');
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-[#1E3A5F]/15 bg-[#F4EFE6]/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-5 py-4 lg:px-8">
        <Link to="/" className="shrink-0 font-['Fraunces'] text-xl tracking-tight" aria-label="HFCursos, inicio">
          HFCursos
        </Link>

        <nav className="hidden items-center gap-6 text-sm md:flex" aria-label="Principal">
          {links.map((link) =>
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
            `border-b pb-0.5 transition-colors ${
            isActive ? 'border-[#C41E3A] text-[#C41E3A]' : 'border-transparent hover:text-[#1E3A5F]'}`

            }>

              {link.label}
            </NavLink>
          )}
        </nav>

        <form onSubmit={onSearch} className="ml-auto hidden min-w-0 flex-1 items-center md:flex md:max-w-xs" role="search">
          <label htmlFor="buscador" className="sr-only">
            Buscar cursos
          </label>
          <div className="flex w-full items-center gap-2 border-b border-[#1E3A5F]/20 pb-1">
            <Search size={16} aria-hidden="true" />
            <input
              id="buscador"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Buscar un curso"
              className="w-full bg-transparent text-sm outline-none placeholder:text-[#1E3A5F]/40" />

          </div>
        </form>

        <div className="hidden items-center gap-3 md:flex">
          {isAuthenticated ?
          <>
              {isAdmin ?
            <>
                <Link to="/admin" className="text-sm hover:text-[#C41E3A]">
                  Solicitudes
                </Link>
                <Link to="/admin/avance" className="text-sm hover:text-[#C41E3A]">
                  Avance
                </Link>
                <Link to="/admin/mensajes" className="text-sm hover:text-[#C41E3A]">
                  Mensajes
                </Link>
              </> :
            null}
              <Link to="/panel" className="text-sm hover:text-[#C41E3A]">
                {user?.userName || 'Panel'}
              </Link>
              <button
              type="button"
              onClick={() => signOut()}
              className="text-sm text-[#1E3A5F]/60 hover:text-[#C41E3A]">

                Salir
              </button>
            </> :

          <Link
            to="/acceso"
            className="group relative inline-flex items-center gap-1.5 overflow-hidden bg-[#C41E3A] px-4 py-2 text-sm font-medium text-white shadow-sm transition-all hover:-translate-y-0.5 hover:bg-[#1E3A5F] hover:shadow-md">

              Acceder
              <ArrowRight size={14} aria-hidden="true" className="transition-transform group-hover:translate-x-0.5" />
            </Link>
          }
        </div>

        <button
          type="button"
          className="ml-auto inline-flex h-10 w-10 items-center justify-center md:hidden"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-controls="menu-movil"
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}>

          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open ?
      <div id="menu-movil" className="border-t border-[#1E3A5F]/10 px-5 py-4 md:hidden">
          <nav className="flex flex-col gap-3 text-base" aria-label="Móvil">
            {links.map((link) =>
          <NavLink key={link.to} to={link.to} onClick={() => setOpen(false)}>
                {link.label}
              </NavLink>
          )}
            {isAdmin ?
          <>
              <NavLink to="/admin" onClick={() => setOpen(false)}>
                Solicitudes
              </NavLink>
              <NavLink to="/admin/avance" onClick={() => setOpen(false)}>
                Avance
              </NavLink>
              <NavLink to="/admin/mensajes" onClick={() => setOpen(false)}>
                Mensajes
              </NavLink>
            </> :
          null}
            <NavLink to="/panel" onClick={() => setOpen(false)}>
              Panel
            </NavLink>
          </nav>
          <form onSubmit={onSearch} className="mt-4" role="search">
            <label htmlFor="buscador-movil" className="sr-only">
              Buscar cursos
            </label>
            <input
            id="buscador-movil"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Buscar un curso"
            className="w-full border border-[#1E3A5F]/20 bg-transparent px-3 py-2 text-sm outline-none" />

          </form>
          <div className="mt-4">
            {isAuthenticated ?
          <button type="button" onClick={() => {signOut();setOpen(false);}} className="text-sm">
                Cerrar sesión
              </button> :

          <Link to="/acceso" onClick={() => setOpen(false)} className="text-sm underline">
                Acceder o registrarse
              </Link>
          }
          </div>
        </div> :
      null}
    </header>);

}

export default Header;